import { resetActionModalContent, setActionModalContent } from '../../Slice';
import Store from '../../Store';

export const resetActionModal = () => {
   Store.dispatch(resetActionModalContent());
};

export const setActionModal = obj => {
   Store.dispatch(setActionModalContent(obj));
};
